<script>
  import { createEventDispatcher } from "svelte";
  import {
    Popup,
    Page,
    Navbar,
    NavRight,
    Link,
    Block,
    Card,
    CardHeader,
    CardContent,
    Button,
    f7,
  } from "framework7-svelte";
  import { TradingService } from "../services/tradingService";

  export let opened = false;
  export let ucc = "";
  export let user = null;
  export let currentBalance = 1000000.00;

  const dispatch = createEventDispatcher();

  let amount = 500000;
  let action = "ADD"; // "ADD" or "SET"
  let isSubmitting = false;

  $: activeUcc = (user ? (user.client_tag || user.ucc) : ucc) || "";
  $: activeName = user ? (user.fullName || "Client") : "";

  async function submitAdjustment() {
    const targetUcc = activeUcc;
    if (!targetUcc) {
      f7.dialog.alert("Please provide a valid Client UCC Tag.", "UCC Required");
      return;
    }
    if (amount <= 0) {
      f7.dialog.alert("Please enter a positive balance amount.", "Invalid Amount");
      return;
    }

    isSubmitting = true;
    try {
      const data = await TradingService.adjustVirtualBalance({
        ucc: targetUcc,
        virtual_balance: Number(amount),
        action: action,
      });

      f7.toast
        .create({
          text: `✓ Virtual capital updated to ₹${Number(data.virtual_balance).toLocaleString("en-IN")} for ${targetUcc}`,
          closeTimeout: 3000,
        })
        .open();

      dispatch("success", { ...data, ucc: targetUcc });
      opened = false;
    } catch (err) {
      f7.dialog.alert(err.message, "Adjustment Failed");
    } finally {
      isSubmitting = false;
    }
  }
</script>

<Popup class="balance-modal" {opened} onPopupClosed={() => (opened = false)}>
  <Page style="background: #0f172a; color: #f8fafc;">
    <Navbar title="💰 Top-Up Client Capital">
      <NavRight>
        <Link popupClose>Close</Link>
      </NavRight>
    </Navbar>

    <Block style="max-width: 480px; margin: 24px auto;">
      <Card style="background: #1e293b; border: 1px solid #334155; border-radius: 12px;">
        <CardHeader style="border-bottom: 1px solid #334155;">
          <div style="font-weight: 600; font-size: 16px;">
            Top-Up: {activeUcc || 'Client'}
            {#if activeName}
              <span style="font-size: 13px; color: #38bdf8; font-weight: normal; margin-left: 6px;">({activeName})</span>
            {/if}
          </div>
        </CardHeader>
        <CardContent>
          <div style="margin-bottom: 16px;">
            <div style="font-size: 12px; color: #94a3b8;">Current Client Balance:</div>
            <div style="font-size: 24px; font-weight: 700; color: #38bdf8;">
              ₹{Number(currentBalance || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>

          <div style="margin-bottom: 16px;">
            <label class="form-label" style="display: block; font-size: 13px; color: #94a3b8; margin-bottom: 6px;">
              Action:
            </label>
            <div style="display: flex; gap: 10px;">
              <Button
                fill={action === "ADD"}
                outline={action !== "ADD"}
                color="green"
                onClick={() => (action = "ADD")}
                style="flex: 1;"
              >
                + Add Funds
              </Button>
              <Button
                fill={action === "SET"}
                outline={action !== "SET"}
                color="blue"
                onClick={() => (action = "SET")}
                style="flex: 1;"
              >
                Set Exact Balance
              </Button>
            </div>
          </div>

          <div style="margin-bottom: 16px;">
            <label class="form-label" style="display: block; font-size: 13px; color: #94a3b8; margin-bottom: 6px;">
              Amount (INR):
            </label>
            <input
              type="number"
              bind:value={amount}
              step="50000"
              min="10000"
              style="width: 100%; background: #0f172a; border: 1px solid #475569; color: #f8fafc; padding: 10px 14px; border-radius: 8px; font-size: 16px;"
            />
          </div>

          <div style="display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap;">
            <Button small outline color="gray" onClick={() => (amount = 100000)}>+₹1 Lakh</Button>
            <Button small outline color="gray" onClick={() => (amount = 500000)}>+₹5 Lakh</Button>
            <Button small outline color="gray" onClick={() => (amount = 1000000)}>+₹10 Lakh</Button>
            <Button small outline color="gray" onClick={() => (amount = 2500000)}>+₹25 Lakh</Button>
          </div>

          <Button
            fill
            large
            color="purple"
            disabled={isSubmitting}
            onClick={submitAdjustment}
          >
            {isSubmitting ? "Updating..." : `✓ Top-Up ${activeUcc || 'Client'} Capital`}
          </Button>
        </CardContent>
      </Card>
    </Block>
  </Page>
</Popup>
